<template>
  <div class="col-sm-6 col-centered mx-auto dashboard">
    <div class="col-sm-4 float-left">
      <div class="card" title="Gestión de usuarios">
        <router-link to="/users" :class="{ disabled: routerLinkDisabled }">
          <font-awesome-icon icon="user" />
        </router-link>
      </div>
    </div>
    <div class="col-sm-4 float-left">
      <div class="card" title="Gestión de preguntas">
        <router-link to="/questions" :class="{ disabled: routerLinkDisabled }">
          <font-awesome-icon icon="question" />
        </router-link>
      </div>
    </div>
    <div class="col-sm-4 float-left">
      <div class="card" title="Acceso a cuestionarios">
        <router-link to="/surveys">
          <font-awesome-icon icon="list" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

	export default {
	  	name: 'Dashboard',
      data() {
        return {
          routerLinkDisabled: true
        }
      }
	};

</script>

<style scoped>
</style>